/*
 * @Author: Chao Yang
 * @Date: 2020-09-07 17:13:47
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-10-22 13:34:16
 */
import { DateRangeTypeEnum } from './date-range-type.enum';
export class AdDateRangeModel {
  oldStartDate?: Date;
  oldEndDate?: Date;
  startDate: Date;
  endDate: Date;
  days?: Date[];
  type?: DateRangeTypeEnum;
}
